import { Input } from "antd";
import { KeywordProps, useKeyword } from "./Keyword.hook";

import { IC_Collapse } from "shared-components/Components/Collapse/web";
import { useRef } from "react";
import { CloseIcon } from "shared-components/Components/CustomIcons/CloseIcon/web";
import "./styles.less"

const { Search } = Input;

export const Keyword = ({ collapsable = false, ...props }: KeywordProps) => {
	const { keyword, isActive, validateValue, handleSubmit, label, labeled } = useKeyword(props);
    const dropdownRef = useRef(null);

	const filter = (
		// <Search
		// 	className="primary"
		// 	value={keyword}
		// 	placeholder={"Buscar por palabra clave"}
		// 	onChange={e => validateValue(e.target.value)}
		// 	onSearch={v => {
		// 		console.log(v)
		// 		handleSubmit(v)}
		// 	}
		// 	enterButton
		// 	allowClear
		// />
		<div ref={dropdownRef} className="keyword-filter__box">
			<input
				className="keyword-filter__input"
				placeholder="Buscá por palabra clave"
				value={keyword}
				onChange={e => validateValue(e.target.value)}
				onBlur={(e) => {
					if (keyword !== "") handleSubmit(e.target.value)
				}}
			/>

			{keyword !== "" ? 
				<button
					className='keyword-filter__box-clear'
					onClick={() => handleSubmit('')}
				>
					<CloseIcon width={10} />
				</button> :
				null
			}
		</div>
	);

	return (
		<div className="filter keyword-filter">
			{collapsable ? 
			<IC_Collapse label={label} isActive={isActive} startOpen={isActive}>
				{filter}
			</IC_Collapse> :
			<>
				<h3 className="filter-title">{label}</h3>
				{filter}
				<hr style={{width:"100%", border:'none', borderTop:'1px solid rgba(0,0,0,.06)', margin:'24px 0'}} />
			</>
			}
		</div>
	);
};

